module.exports = __webpack_public_path__ + "img/flag_no.27fb1e65.svg";